import { Children, cloneElement } from 'react';
import styled from 'styled-components';
import { Stack } from '@kiwicom/orbit-components';
import type { TranslationType } from '@kiwicom/account-consts';

import Text from '../Text';
import InclusivelyHidden from '../InclusivelyHidden';

type Props = {
  readonly value?: string;
  readonly label?: JSX.Element;
  readonly children: JSX.Element | JSX.Element[];
  readonly onChange: (arg0: string) => void;
  readonly dataTest?: string;
  readonly error?: TranslationType | null | undefined;
};

type WrapperProps = {
  dataTest: string;
};

const Wrapper = styled.fieldset.attrs<WrapperProps>(({ dataTest }) => ({
  'data-test': dataTest,
}))<WrapperProps>`
  width: 100%;
  border: none;
`;

const ChoiceTiles = ({ dataTest, label, children, onChange, value, error }: Props): JSX.Element => {
  const checkBoxes = Children.map(children, (child, index) => {
    return cloneElement(child, {
      currentValue: value,
      onValueChange: onChange,
      index,
    });
  });
  const errorMessage = error && (
    <Text size="small" weight="bold" type="critical">
      {error}
    </Text>
  );
  return (
    <Wrapper dataTest={dataTest}>
      <InclusivelyHidden element="legend">
        {/* These elements will be announced by the screen reader once the first child is given focus */}
        <span>{label}</span>
        <span>{errorMessage}</span>
      </InclusivelyHidden>
      <label>
        {label}
        <Stack spacing="200" flex align="center" wrap>
          {checkBoxes}
        </Stack>
      </label>
      {errorMessage}
    </Wrapper>
  );
};

export default ChoiceTiles;
